var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 289.57 95.135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 287,
    height: 94,
    x: 1.793,
    y: -0.377,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAR8AAABeCAYAAAAaJBAwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGOSURBVHgB7dnBTcNAFEXRCZWkAyiBTiglpVAKLdABogJKGJwYiUWUXTJ3c470Nvb+6lseY87TZQALPQ2AgPgACfEBEuIDJMQHSIgPkBAfICE+QEJ8gIT4AAnxARLiAyTEB0iID5AQHyAhPkBCfICE+AAJ8QES4gMkxAdIiA+QEB8gIT5AQnyAhPgACfEBEuIDJMQHSIgPkBAfICE+QEJ8gIT4AAnxARLiAyTEB0iID5AQHyAhPkBCfICE+AAJ8QES4gMkxAdIiA+QEB8gIT5AQnyAhPgACfEBEuIDJMQHSIgPkBAfICE+QEJ8gIT4AAnxARLiAyTEB0iID5AQHyAhPkBCfICE+AAJ8QES4gMkxAdIiA+QEB8gIT5AQnyAhPgACfEBEuIDJMQHSIgPkBAfICE+QEJ8gIT4AAnxARLiAyTEB0ic4/O97TgAlprzuO1nACw358e2twGw1Jyvl+vnfAUBLDXnaduXAAHr/QfIJxjwUIerJ/vl8z72P2CffwO4q8PNN3uEnre9DIA7+wWtKi5B9NhwFgAAAABJRU5ErkJggg=="
  }, /*#__PURE__*/React.createElement("title", null, "Vector 63"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep23);
export default __webpack_public_path__ + "static/media/step_2 (3).ed187f2a67e1f966c5c4f882aaed2596.svg";
export { ForwardRef as ReactComponent };